import { Controller } from "@hotwired/stimulus"

// The server-side search box (shared/_search): submits its GET form into a Turbo
// frame while typing, debounced, and owns the box's ✕ (a `clear` target),
// shown while the box holds text. The client-side kind is filter_controller.js.
const DEBOUNCE_MS = 200

export default class extends Controller {
  static targets = ["input", "clear"]

  // The page may open with ?query=, so the ✕ is synced on connect too.
  connect() {
    this.toggleClear()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  queue() {
    this.toggleClear()
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.element.requestSubmit(), DEBOUNCE_MS)
  }

  clear() {
    clearTimeout(this.timer)
    this.inputTarget.value = ""
    this.inputTarget.focus()
    this.toggleClear()
    this.element.requestSubmit()
  }

  toggleClear() {
    if (this.hasClearTarget) this.clearTarget.hidden = this.inputTarget.value === ""
  }
}
